export default class Star {
  constructor() {
    this.star = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    this.star.setAttribute('aria-hidden', true);
    this.star.setAttribute('focusable', false);
    this.star.setAttribute('fill', 'none');
    this.star.setAttribute('viewBox', '0 0 16 16');
  }

  /**
   * Set a full star inside of SVG element
   * @returns {SVGElement} - a SVG element
   */
  setFullStar() {
    this.star.innerHTML = `
      <path fill="#633293" d="m8 0 1.978 5.64L16 5.762 11.2 9.37l1.744 5.716L8 11.675l-4.944 3.41L4.8 9.37 0 5.762l6.022-.121L8 0Z"/>
    `;
    return this.star;
  }

  /**
   * Set a half star inside of SVG element
   * @returns {SVGElement} - a SVG element
   */
  setHalfStar() {
    this.star.innerHTML = `
      <path fill="#633293" d="M8 0v11.675l-4.944 3.41L4.8 9.37 0 5.762l6.022-.121L8 0Z"/>
      <path stroke="#633293" d="m9.506 5.806.114.327.348.007 4.572.092-3.64 2.739-.28.21.102.335 1.325 4.342-3.764-2.595L8 11.067l-.284.196-3.764 2.595 1.326-4.342.103-.335-.28-.21L1.46 6.232l4.573-.091.348-.007.114-.327L8 1.51l1.506 4.296Z"/>
    `;
    return this.star;
  }

  /**
   * Set a empty star inside of SVG element
   * @returns {SVGElement} - a SVG element
   */
  setEmptyStar() {
    this.star.innerHTML = `
      <path stroke="#633293" d="m9.506 5.806.114.327.348.007 4.572.092-3.64 2.739-.28.21.102.335 1.325 4.342-3.764-2.595L8 11.067l-.284.196-3.764 2.595 1.326-4.342.103-.335-.28-.21L1.46 6.232l4.573-.091.348-.007.114-.327L8 1.51l1.506 4.296Z"/>
    `;
    return this.star;
  }

  /**
   * Set a partial star with custom fill percentage
   * @param {number} percent - Fill percentage (0-100)
   * @returns {SVGElement} - a SVG element with partial fill
   */
  setPartialStar(percent) {
    const gradientId = `star-gradient-${Math.random().toString(36).substr(2, 9)}`;

    this.star.innerHTML = `
      <defs>
        <linearGradient id="${gradientId}">
          <stop offset="${percent}%" stop-color="#633293"/>
          <stop offset="${percent}%" stop-color="transparent"/>
        </linearGradient>
      </defs>
      <path fill="url(#${gradientId})" stroke="#633293" d="m9.506 5.806.114.327.348.007 4.572.092-3.64 2.739-.28.21.102.335 1.325 4.342-3.764-2.595L8 11.067l-.284.196-3.764 2.595 1.326-4.342.103-.335-.28-.21L1.46 6.232l4.573-.091.348-.007.114-.327L8 1.51l1.506 4.296Z"/>
    `;
    return this.star;
  }
}
